import { createPinia } from "pinia";

const pinia = createPinia();

// 导出
export default pinia;
